import { apiClient } from './api';
import type {
  Journal,
  JournalEntry,
  JournalEntryListItem,
  JournalEntryDetail,
  JournalEntryFeedback,
  CreateJournalPayload,
  UpdateJournalPayload,
  CreateEntryPayload,
  UpdateEntryPayload,
} from '../types/api.types';

const BASE = '/journals';

export const journalsService = {
  listJournals: async (): Promise<Journal[]> => {
    const { data } = await apiClient.get<Journal[]>(BASE);
    return data;
  },

  createJournal: async (payload: CreateJournalPayload): Promise<Journal> => {
    const { data } = await apiClient.post<Journal>(BASE, payload);
    return data;
  },

  updateJournal: async (id: string, payload: UpdateJournalPayload): Promise<Journal> => {
    const { data } = await apiClient.put<Journal>(`${BASE}/${id}`, payload);
    return data;
  },

  deleteJournal: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${id}`);
  },

  listEntries: async (journalId: string): Promise<JournalEntryListItem[]> => {
    const { data } = await apiClient.get<JournalEntryListItem[]>(`${BASE}/${journalId}/entries`);
    return data;
  },

  createEntry: async (journalId: string, payload: CreateEntryPayload): Promise<JournalEntry> => {
    const { data } = await apiClient.post<JournalEntry>(`${BASE}/${journalId}/entries`, payload);
    return data;
  },

  getEntry: async (journalId: string, entryId: string): Promise<JournalEntryDetail> => {
    const { data } = await apiClient.get<JournalEntryDetail>(`${BASE}/${journalId}/entries/${entryId}`);
    return data;
  },

  updateEntry: async (journalId: string, entryId: string, payload: UpdateEntryPayload): Promise<JournalEntry> => {
    const { data } = await apiClient.put<JournalEntry>(`${BASE}/${journalId}/entries/${entryId}`, payload);
    return data;
  },

  deleteEntry: async (journalId: string, entryId: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${journalId}/entries/${entryId}`);
  },

  requestReview: async (journalId: string, entryId: string): Promise<JournalEntryFeedback> => {
    const { data } = await apiClient.post<JournalEntryFeedback>(
      `${BASE}/${journalId}/entries/${entryId}/review`
    );
    return data;
  },
};
